import { IncludeOption } from '@kizenapps/engine';

export const getParamFromAuth = (auth: any) => (key: IncludeOption) => {
  if (key === 'email' && auth.teamMember?.email) {
    return auth.teamMember.email;
  } else if (key === 'name' && auth.teamMember?.full_name) {
    return auth.teamMember.full_name;
  } else if (key === 'business_id' && auth.chosenBusiness?.id) {
    return auth.chosenBusiness.id;
  } else if (key === 'user_id' && auth.teamMember?.id) {
    return auth.teamMember.id;
  }
};
